import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Results from "./pages/Results";
import PropertyDetail from "./pages/PropertyDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PostListing from "./pages/PostListing";
import Dashboard from "./pages/Dashboard";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import { RateProvider } from "./context/RateContext";
import { About, Careers, Press, Help, Privacy, Terms } from "./pages/StaticPages";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import EditListing from "./pages/EditListing";
import ForAgencies from "./pages/ForAgencies";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <RateProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/search" element={<Results />} />
                <Route path="/property/:id" element={<PropertyDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/post" element={<PostListing />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/about" element={<About />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/press" element={<Press />} />
                <Route path="/help" element={<Help />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/profile/:id" element={<Profile />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/edit/:id" element={<EditListing />} />
                <Route path="/for-agencies" element={<ForAgencies />} />
              </Routes>
              <Toaster />
            </BrowserRouter>
          </RateProvider>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
